import { DeclineReasonEnum } from './declineReason.enum';
import { CancelReason } from './cancelReason';

export enum EmploymentInviteeStatusEnum {
  OPEN = 'OPEN',
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  DECLINED = 'DECLINED',
  CANCELLED = 'CANCELLED',
  BOOKED = 'BOOKED',
  POSSIBLE_CANDIDATE = 'POSSIBLE_CANDIDATE',
}

export type EmploymentInviteeStatusReason = {
  reason: CancelReason | DeclineReasonEnum;
  reasonDescription?: string;
  informInviteeOfReason?: boolean;
};
